import AssetAccess from './AssetAccess'
export default AssetAccess
